// src/components/BundlePromise.jsx
import React from "react";
import "../styles/BundlePromise.css";

const BundlePromise = () => {
    return (
        <section className="promise-section">
            <div className="container">
                <div className="promise-header">
                    <span className="promise-eyebrow">The Bundle Promise</span>
                    <h2 className="promise-title">Quality Without Compromise</h2>
                    <div className="promise-rule" />
                </div>

                <div className="row">
                    {/* Quality Card */}
                    <div className="col-md-4 mb-4 mb-md-0">
                        <div className="promise-card">
                            <i className="fas fa-crown promise-icon"></i>
                            <h3>Unmatched Quality</h3>
                            <p>Premium hair, carefully sourced for absolute perfection from root to tip.</p>
                        </div>
                    </div>

                    {/* Delivery Card */}
                    <div className="col-md-4 mb-4 mb-md-0">
                        <div className="promise-card">
                            <i className="fas fa-box-open promise-icon"></i>
                            <h3>Express Delivery</h3>
                            <p>Carefully packaged in our signature luxury boxes and shipped securely directly to your address.</p>
                        </div>
                    </div>

                    {/* Durability Card */}
                    <div className="col-md-4">
                        <div className="promise-card">
                            <i className="fas fa-gem promise-icon"></i>
                            <h3>Pure Durability</h3>
                            <p>Hair that lasts. Our bundles wash flawlessly, hold curls beautifully, and style effortlessly.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BundlePromise;